export const commonEnvironment = {
    LOCAL_DATE_FORMAT: 'dd.MM.yyyy',
    LOCAL_DATE_TIME_FORMAT: 'dd.MM.yyyy HH:mm',
    API_DATE_FORMAT: 'yyyy-MM-dd',
    GRANT_TYPE: 'password',
}